import React from 'react';
import './../css/Form.css';

const Successful = () => {
    return (
        <div className='container'>
            <div className="app-wrapper">
                <h1 className="form-success">
                    Account Created!
                </h1>
            </div>
        </div>
    )
}

export default Successful;
